<template>

	<div class="innerBox">
		<h2 class="mb-4">{{title}}</h2>
		<component
			v-if="data && previousCheckingCondition"
			:is="'page' + page"
			:data="data"
			:carType="carType"
			:getRecordedCondition="getRecordedCondition"
			:page="page" 
			v-on:nextPage="nextPage"
			v-on:backPage="backPage"
			:checklistSettings="checklistSettings"
			:title="title"
			:exit="exit"
			:previousCheckingCondition="previousCheckingCondition"
			@changeCarType="changeCarType"
			:checkSettingsChecklist="checkSettings"
			:updateSubmit="{curProcess , endProcess}"
		>
		</component>
	</div>

</template>

<script>

import page2 from './workOrderFormPage/page2'
import page3 from './workOrderFormPage/page3'
import page4 from './workOrderFormPage/page4'
import page5 from './workOrderFormPage/page5'
import page6 from './workOrderFormPage/page6'
import page7 from './workOrderFormPage/page7'
import page8 from './workOrderFormPage/page8'
import page8Exit from './workOrderFormPage/page8Exit'
import './workOrderFormPage/sedan.css'
import './workOrderFormPage/minibus.css'
import UploadImage from '@/components/modal/uploadImage'

import moment from 'moment'

export default {
	components : {
		page2,
		page3,
		page4,
		page5,
		page6,
		page7,
		page8,
		page8Exit
	},
	watch : {
	},
	mounted () {
		this.getWoDetail()
		
		
		if(this.$route.params.type == 'exit-check') {
			this.title = 'Pengecekan Kondisi Selesai Work Order'
			this.exit = true
			this.data = this.dataSet
			// console.log(this.$store.state.lastDataExitCheck.form_code, this.form_code)
			if(this.$store.state.lastDataExitCheck && this.$store.state.lastDataExitCheck.form_code) {
				this.$swal.fire({
				title: 'Load Save Data?',
					text: "System mendeteksi ada data yang disimpan tetapi belum terunggah! Apakah anda mau mengulang atau melanjuti data sebelumnya?",
					icon: 'warning',
					confirmButtonText : 'Lanjut ',
					cancelButtonText : 'Ulang',
					cancelButtonColor : 'red',
					showCancelButton: true
				}).then((result) => {
					if (result.value) {
						this.data = this.$store.state.lastDataExitCheck
			
					}
					else {
						this.$store.state.lastDataExitCheck = this.data
					}
				})
			}
			else {
				this.$store.state.lastDataExitCheck = this.data
			}
			
			this.loadChecklistSettings()
		}
		else {
			this.title = 'Periksa Kondisi Kedatangan Mobil'
			this.getRecordedCondition = true
			
		}
	},
	methods : {
		getWoDetail () {
			this.$http.get(`/api/v1/workorder/${this.form_code}/detail`)
			.then((resp) => {
				
				let data = resp.data.data
				this.previousCheckingCondition = data

				if(!data.condition) {
					data.condition = {
						figure : {

						},
						figureOverall : {
							"front" : { image : []  },
							"rear" : { image : []  },
							"left" : { image : []  },
							"right" : { image : []  },
							'atap' : { image : []  }
						},
						checklist: {},
					}
				}

				this.checkSettings = data.condition.checklist ? data.condition.checklist : []
				if(this.$route.params.type == 'exit-check') {
					data.condition.checklist = this.checkSettings
				}
				else {
					this.dataSet.customer = data.customer
					this.dataSet.customer_car = Object.assign({} , data.customer_car);
					delete this.dataSet.customer_car.sim_img
					delete this.dataSet.customer.address
					delete this.dataSet.customer_car.price
					delete this.dataSet.customer.address
					delete this.dataSet.customer_car.paint_name
					delete this.dataSet.customer_car.insurance
					delete this.dataSet.customer_car.current_km
					this.data = this.dataSet
					this.data.form_code = this.form_code

				}
				
				// console.log(this.$store.state.lastDataLateCheck.form_code)
				// if(this.$store.state.lastDataLateCheck && this.$store.state.lastDataLateCheck.form_code) {
				// 	this.$swal.fire({
				// 	title: 'Load Save Data?',
				// 		text: "System mendeteksi ada data yang disimpan tetapi belum terunggah! Apakah anda mau mengulang atau melanjuti data sebelumnya?",
				// 		icon: 'warning',
				// 		confirmButtonText : 'Lanjut ',
				// 		cancelButtonText : 'Ulang',
				// 		cancelButtonColor : 'red',
				// 		showCancelButton: true
				// 	}).then((result) => {
				// 		if (result.value) {
				// 			this.data = this.$store.state.lastDataLateCheck
				
				// 		}
				// 		else {
				// 			this.$store.state.lastDataLateCheck = this.data
				// 		}
				// 	})
				// }
				// else {
				// 	this.$store.state.lastDataLateCheck = this.data
				// }

				
				this.loadChecklistSettings()

			})
			.catch((err) => {
				console.log(err)
			})
		},
		nextPage (checkSettingsChecklist = null) {
			console.log(this.page)
			if(this.page == 7 && this.$route.params.type == 'exit-check') {
				this.page++;
				this.page = this.page + 'Exit'
				
				
			}
			else if(this.page == '8Exit') {
				this.data.condition.checklist = checkSettingsChecklist
				this.createWorkOrder()
			}
			else if(this.$route.params.type == 'exit-check') {
				this.page++
			}

			else {
				this.finishChecking()
			}
		},
		backPage () {
			if(this.page == '8Exit') {
				this.page = 7
			}
			else
				this.page--
		},
		finishChecking () {
			let processedData = {}
			let data = JSON.parse(JSON.stringify(this.data))
			let keys = Object.keys(this.data)

			if(this.page == 2) {
				processedData.condition = {
					accu: data.condition.accu,
					fuel: data.condition.fuel
				}

				processedData.customer_car = data.customer_car
				processedData.customer_car.current_km = processedData.customer_car.last_km = parseInt(processedData.customer_car.current_km.split(",").join(""))
			}
			else if ( this.page > 2 && this.page < 8) {
				let arr = ['front' , 'left' , 'rear' , 'right' , 'atap']
				processedData.condition = {}
				processedData.condition.figure = {} 
				processedData.condition.figure[arr[this.page - 3]] = data.condition.figure[this.carType][arr[this.page - 3]]
				processedData.condition.figureOverall = {}
				processedData.condition.figureOverall[arr[this.page - 3]] = data.condition.figureOverall[this.carType][arr[this.page - 3]]
				
			}
				
			if(this.page == 8) {
				processedData.conditionChecked = true
				console.log(data.condition)
				processedData.condition = {
					checklist : data.condition.checklist
				}
				processedData.condition.ttdCustomer = data.condition.ttdCustomer
			}


			this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : processedData})
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Data Berhasil Disimpan!'])

				if(this.page == 8) {
					this.$store.state.lastDataLateCheck = null
					this.$store.dispatch('triggerAlert' , [true , 'Periksa Mobil Berhasil'])
					this.$router.push({name : 'WorkOrderDetailV2', query: {wo:this.$route.params.form_code.replace(/"/g, "")}})
				}
				else {
					this.page++
				}
			})
			.catch((err) => {
				console.log(err.response)
				let errMessage = err.response.data.data
				if(typeof errMessage == 'string') {
					if(errMessage.includes('registration'))
						errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

					this.$store.dispatch('triggerAlert' , [false , errMessage])
					this.apiLoading = false
				}
				else if(errMessage.nativeError) {
					this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
				}
				else {
					let keys = Object.keys(errMessage)
					let arr = []
					for(var i = 0 ; i < keys.length ; i++) {
						let message = errMessage[keys[i]][0].message
						arr.push(`${this.translate(keys[i])} ${message}`)

					}
					this.$store.dispatch('triggerAlert' , [false , arr])
					this.apiLoading = false
				}
			})
				
		},
		async processDataPostCondition (data) {
			let error = false
			let keys = Object.keys(data.post_condition)
			this.curProcess = 0
			this.endProcess = keys.length;
			try {
				for(var i = 0 ;  i < keys.length ; i++) {
					this.curProcess = i
					let sendData = {
						post_condition : {}
					}

					sendData.post_condition[keys[i]] = data.post_condition[keys[i]]

					let resp = await this.$http.patch('/api/v1/workorder/' + this.form_code , {data : sendData})
					
					this.$store.dispatch('triggerAlert' , [true , `${this.curProcess} / ${keys.length} Process Done`])
				}
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Failed to Close Work Order' , err])
				console.log(err)
				error = true
				return error
			}

			return error
			
		},
		async createWorkOrder() {
			try {
				let data = JSON.parse(JSON.stringify(this.data))
				data.post_condition = JSON.parse(JSON.stringify(data.condition))
				delete data.condition
				delete data.customer
				delete data.customer_car

				this.apiLoading = true

				data.post_condition.figureOverall = data.post_condition.figureOverall[this.carType]
				data.post_condition.figure = data.post_condition.figure[this.carType]

				
				let result = await this.processDataPostCondition(data)

				if(result){
					throw new Error('Failed to Update Work Order');
					this.endProcess = 0
				} 


				this.$http.patch('/api/v1/workorder/done/' + this.form_code)
				.then((resp)=> {
					// this.data.form_code = resp.data.data.form_code
					// this.$store.state.lastData = null
					this.apiLoading = false
					this.$store.state.lastDataExitCheck = null
					this.$store.dispatch('triggerAlert' , [true , 'WO Berhasil Ditutup'])
					this.$router.push({name : 'WorkOrderDetailV2', query: {wo:this.$route.params.form_code.replace(/"/g, "")}})

				})
				.catch((err) => {
					this.$store.dispatch('triggerAlert' , [false , 'Error!' , err])
					console.log(err)
				})
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Error!' , err])
			}
			
		},
		changeCarType (carType) {
			this.carType = carType
		},
		loadChecklistSettings () {
			this.$http.get('/api/v1/workorder/settings')
			.then((resp) => {
				this.checklistSettings = resp.data.data
				let checklist = {}

				for (var i = 0 ; i < this.checklistSettings.length ; i++) {
					checklist[this.checklistSettings[i].name] = {
						condition : '',
						img : null
					}
				}

				this.data.condition.checklist = Object.assign({} , checklist)
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	data () {
		return {
			carType : 'sedan',
			title : '',
			exit : false,
			curProcess : 0,
			endProcess : 0,
			apiLoading : false,
			showConditionExterior : false,
			checklistSettings : null,
			previousCheckingCondition : null,
			form_code : this.$route.params.form_code,
			getRecordedCondition : false,
			page : 2,
			sliderValues: [
				{
					label: "Kosong",
					value: "E"
				},
				{
					label: "1/8",
					value: "1/8"
				},
				{
					label: "1/4",
					value: "1/4"
				},
				{
					label: "3/8",
					value: "3/8"
				},
				{
					label: "1/2",
					value: "1/2"
				},
				{
					label: "5/8",
					value: "5/8"
				},
				{
					label: "3/4",
					value: "3/4"
				},
				{
					label: "7/8",
					value: "7/8"
				},
				{
					label: "Penuh",
					value: "F"
				}
			],
			data : null,
			checkSettings : null,
			dataSet : {
				condition: {
						accu: {
							health : '0',
							charging : '0'
						},
						fuel: 'E',
						checklist: {},
						figureOverall : {
							sedan : {
								"front" : { image : []  },
								"rear" : { image : []  },
								"left" : { image : []  },
								"right" : { image : []  },
								'atap' : { image : []  }
							},
							minibus : {
								"front" : { image : []  },
								"rear" : { image : []  },
								"left" : { image : []  },
								"right" : { image : []  },
								'atap' : { image : []  }
							}
							
						},
						figure: {
							sedan : {
								front : {
									carWindowDepan : { desc : ''  },
									kapMesin : { desc : ''  },
									headLightKanan : { desc : ''  },
									grill : { desc : ''  } ,
									emblem : { desc : ''  },
									headLightKiri : { desc : ''  },
									bumperDepan : { desc : ''  },
									fogLightKiri : { desc : ''  },
									fogLightKanan : { desc : ''  },
									spionDepanKiri : { desc : ''  },
									spionDepanKanan : { desc : ''  },
								},
								rear : {
									carWindowBelakang : { desc : ''  },
									bagasi : { desc : ''  },
									backLightKiri : { desc : ''  },
									emblem : { desc : ''  },
									backLightKanan : { desc : ''  },
									bumperBelakang : { desc : ''  },
									bumperLightKiri : { desc : ''  },
									bumperLightKanan : { desc : ''  },
								},
								atap : {
									atapMobil : { desc : ''  },
									sunRoof : { desc : ''  }
								},
								left : {
									fenderDepanKiri : { desc : ''  },		
									rodaDepanKiri : { desc : ''  },
									kacaDepanKiri : { desc : ''  }, 
									pintuDepanKiri : { desc : ''  },
									sideSkirtKiri : { desc : ''  },
									kacaBelakangKiri : { desc : ''  },
									kacaMiniBelakangKiri : { desc : ''  },
									pintuBelakangKiri : { desc : ''  },
									sideRoofKiri : { desc : ''  },
									fenderBelakangKiri : { desc : ''  },
									tankiMobil : { desc : ''  },
									rodaBelakangKiri :{ desc : ''  },
								},
								right : {
									rodaBelakangKanan :{ desc : ''  },
									fenderBelakangKanan : { desc : ''  },
									sideRoofKanan : { desc : ''  },
									pintuBelakangKanan : { desc : ''  },
									kacaMiniBelakangKanan : { desc : ''  },
									kacaBelakangKanan : { desc : ''  },
									sideSkirtKanan : { desc : ''  },
									kacaDepanKanan : { desc : ''  }, 
									pintuDepanKanan : { desc : ''  },
									rodaDepanKanan : { desc : ''  },
									fenderDepanKanan : { desc : ''  },		
								}
							},
							minibus : {
								front : {
									carWindowDepan : { desc : ''  },
									kapMesin : { desc : ''  },
									headLightKanan : { desc : ''  },
									grill : { desc : ''  } ,
									emblem : { desc : ''  },
									headLightKiri : { desc : ''  },
									bumperDepan : { desc : ''  },
									fogLightKiri : { desc : ''  },
									fogLightKanan : { desc : ''  },
									spionDepanKiri : { desc : ''  },
									spionDepanKanan : { desc : ''  },
								},
								rear : {
									carWindowBelakang : { desc : ''  },
									bagasi : { desc : ''  },
									backLightKiri : { desc : ''  },
									emblem : { desc : ''  },
									backLightKanan : { desc : ''  },
									bumperBelakang : { desc : ''  },
									bumperLightKiri : { desc : ''  },
									bumperLightKanan : { desc : ''  },
								},
								atap : {
									atapMobil : { desc : ''  },
									sunRoof1 : { desc : ''  },
									sunRoof2 : { desc : ''  }
								},
								left : {
									fenderDepanKiri : { desc : ''  },		
									rodaDepanKiri : { desc : ''  },
									kacaDepanKiri : { desc : ''  }, 
									pintuDepanKiri : { desc : ''  },
									sideSkirtKiri : { desc : ''  },
									kacaBelakangKiri : { desc : ''  },
									kacaMiniDepanKiri : { desc : ''  },
									pintuBelakangKiri : { desc : ''  },
									sideRoofKiri : { desc : ''  },
									kacaPalingBelakangKiri : { desc : '' },
									fenderBelakangKiri : { desc : ''  },
									tankiMobil : { desc : ''  },
									rodaBelakangKiri :{ desc : ''  },
									
									
								},
								right : {
									rodaBelakangKanan :{ desc : ''  },
									fenderBelakangKanan : { desc : ''  },
									sideRoofKanan : { desc : ''  },
									pintuBelakangKanan : { desc : ''  },
									kacaMiniDepanKanan : { desc : ''  },
									kacaBelakangKanan : { desc : ''  },
									kacaPalingBelakangKanan : { desc : '' },
									sideSkirtKanan : { desc : ''  },
									kacaDepanKanan : { desc : ''  }, 
									pintuDepanKanan : { desc : ''  },
									rodaDepanKanan : { desc : ''  },
									fenderDepanKanan : { desc : ''  },	
									kacaPalingBelakangKanan : { desc : '' }
								}
							}
						}
					}
			}
		}
	}
}
</script>